import {errorHttpMessage} from '@/utils/errorDecodeUtil'

/**
 * HCSO-2786 — Acción de Vuex para reactivar un elemento de catálogo desactivado.
 *
 * Los 13 catálogos de administración comparten el mismo contrato de restore
 * (`POST .../{id}/restore`, respuesta en `result.result`); lo único que cambia
 * es el cliente del microservicio y el segmento de ruta del catálogo.
 *
 * El backend responde 422 si ya existe un elemento activo con el mismo nombre y
 * NO reactiva; ese mensaje se propaga tal cual para mostrarlo al usuario.
 *
 * @param {Object} client Cliente axios del microservicio (configurationClient, vaccinationClient...).
 * @param {string} basePath Ruta del catálogo sin el id, p. ej. '/catalog/subgroups'.
 * @returns {Function} Acción `restoreById` lista para exportar desde el store del módulo.
 */
export const makeRestoreAction = (client, basePath) => async ({commit}, id) => {
    try {
        const {data: result} = await client.post(`${basePath}/${id}/restore`)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}
